// extracted by mini-css-extract-plugin
module.exports = {"container":"productPage_container__OuPWP","relatedProducts":"productPage_relatedProducts__cGV98"};